// extracted by mini-css-extract-plugin
module.exports = {"Description":"AddUserModal_Description__34bm8","MultiSelectDropdown":"AddUserModal_MultiSelectDropdown__-Urvt","RolesContainer":"AddUserModal_RolesContainer__3q8LX"};